import translations from './translations.json';

export const getRosterfyTranslation = async () => {
    return translations;
};
